(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('urlReputationDao', ["http", function (http) {
        return {
            updateWhitelistUrls: function (add_urls, remove_urls) {
                return http.post('/api/v1/url_reputation/whitelist-links').body({
                    add_urls: add_urls || [],
                    remove_urls: remove_urls || []
                });
            },
            getWhitelistUrls: function () {
                return http.get('/api/v1/url_reputation/whitelist-links');
            },
            getEmailUrls: function (entity_type, entity_id) {
                return http.get('/api/v1/url_reputation/links/' + entity_type + '/' + entity_id);
            }
        };
    }]);
}());